import { FinishDisplayName, FinishHandle } from "@/models/products/finish";

export const formatTitle = (title: string, part: string): string => {
  let result = "";
  if (title.indexOf(" ")) {
    if (part == "a") {
      result = title.substr(0, title.indexOf(" "));
    } else {
      result = title.substr(title.indexOf(" ") + 1);
    }
  } else {
    return title;
  }
  return result;
};

export const getImg = (img: string): string => {
  return img + "?width=285";
};

export const makeTitleCase = (option: string) => {
  return option
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ")
    .replaceAll("_", " ")
    .replaceAll("-", " ");
};

export const getFinishImage = (handle: string | FinishHandle): string => {
  let img = "";
  for (const value in FinishHandle) {
    if (handle === "msa" || handle === "ss" || handle === "gs") {
      img = require(`../assets/images/finishes/ms.jpg`);
    } else if (FinishHandle[value] === handle) {
      img = require(`../assets/images/finishes/${handle}.jpg`);
    }
  }
  return img;
};

export const getFinishName = (
  stringHandle: FinishHandle
): FinishDisplayName => {
  const handle = stringHandle as FinishHandle;
  let name = "" as FinishDisplayName;
  switch (handle) {
    case FinishHandle.MS:
      name = FinishDisplayName.MS;
      break;
    case FinishHandle.WG:
      name = FinishDisplayName.WG;
      break;
    case FinishHandle.BK:
      name = FinishDisplayName.BK;
      break;
    case FinishHandle.WH:
      name = FinishDisplayName.WH;
      break;
    case FinishHandle.BZ:
      name = FinishDisplayName.BZ;
      break;
    case FinishHandle.SR:
      name = FinishDisplayName.SR;
      break;
    case FinishHandle.HW:
      name = FinishDisplayName.HW;
      break;
    case FinishHandle.MSA:
      name = FinishDisplayName.MSA;
      break;
    case FinishHandle.SM:
      name = FinishDisplayName.SM;
      break;
    case FinishHandle.SS:
      name = FinishDisplayName.SS;
      break;
    case FinishHandle.GS:
      name = FinishDisplayName.GS;
      break;
    case FinishHandle.ASH:
      name = FinishDisplayName.ASH;
      break;
    case FinishHandle.GBK:
      name = FinishDisplayName.GBK;
      break;
  }
  return name;
};
